import { clsx } from 'clsx'

import { Event, RecurringEventFrequency } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { LivePulse } from '../../../../common/components/LivePulse.js'
import { dayjs } from '../../../../common/lib/dayjs.js'
import { T } from '../../../../i18n/components/T.js'
import { useStaticIntl } from '../../../../i18n/index.js'

import { recurrenceBadgeTextFactory } from './utils.js'

interface Props {
  event: Event
}

export const EventStatusBadges = ({ event }: Props) => {
  const isOngoing =
    dayjs(event.startTime).isSameOrBefore(dayjs()) &&
    dayjs(event.endTime).isSameOrAfter(dayjs())
  const isRecurring =
    event.recurrenceConfig &&
    event.recurrenceConfig?.frequency !== RecurringEventFrequency.once
  const recurrenceBadgeText = useStaticIntl(
    recurrenceBadgeTextFactory,
    event.recurrenceConfig?.frequency,
  )

  return (
    <div className={clsx('flex items-center gap-2 flex-wrap')}>
      {isOngoing && (
        /* Using hardcoded colors because it's a live indicator and doesn't have to follow theme colors   */
        <div className="flex items-center gap-2 text-[#ffdfda] !bg-[#712821] rounded-base p-0.5 px-2 shrink-0">
          <LivePulse />
          <T id="Event.Status.LiveNow" defaultMessage="Live now" />
        </div>
      )}
      {isRecurring && (
        <div className="flex items-center gap-2 text-content-on-primary bg-action-primary rounded-base p-0.5 px-2 shrink-0">
          <SvgIcon name="refresh" size="sm" />
          {recurrenceBadgeText}
        </div>
      )}
    </div>
  )
}
